// VideosList.jsx
import React from "react";
import { Stack, Typography } from "@mui/material";
import { VideoCard } from "./VideoCard";

export const VideosList = ({ videos, onVideoSelect, loading, moreVideosText }) => {
  const shouldShowHeader = Boolean(moreVideosText);
  const hasVideos = Array.isArray(videos) && videos.length > 0;

  if (!loading && !hasVideos && !shouldShowHeader) return null;

  return (
    <Stack spacing={1} mt={1.5} sx={{ backgroundColor: shouldShowHeader ? "lightgray" : "transparent" }}>
      {shouldShowHeader && (
        <Typography variant="body1" p={1} pb={0}>
          {moreVideosText}
        </Typography>
      )}
      <div
        style={{
          maxHeight: "150px",
          overflow: "scroll"
        }}>
        {loading ? (
          <Typography p={2}>Loading...</Typography>
        ) : (
          videos?.map((video, index) => (
            <VideoCard
              key={video.id || index}
              video={video}
              onClick={() => onVideoSelect(video)}
            />
          ))
        )}
      </div>
    </Stack>
  );
};
